// /control — «Контроль» (003, сценарий 5): таблица открытых пунктов. Право — control.read;
// какие документы видны, решает сервер по областям. Поиск, фильтры, вид и сортировка — в адресе
// под именами запроса control.items: /control?asOf=today&group=overdue (приёмка 0.3.1, T041).
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import { ControlPage } from '../../features/control/ControlPage.tsx';
import { parseControlSearch } from '../../features/control/search.ts';
import type { ControlSearch } from '../../features/control/search.ts';
import { requireSection } from '../../shell/permissions.ts';

export const Route = createFileRoute('/_app/control')({
  validateSearch: parseControlSearch,
  beforeLoad: requireSection('control'),
  staticData: { crumb: 'Контроль' },
  component: ControlRoute,
});

function ControlRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate();
  const onSearchChange = useCallback(
    (next: ControlSearch) => void navigate({ to: '/control', search: next, replace: true }),
    [navigate],
  );
  return <ControlPage search={search} onSearchChange={onSearchChange} />;
}
